<template>
  <custom-popup
    v-model="isOpen"
    :cons="{ title: $t('ready_card_samples') }"
    hide-confirm
    hide-overlay
    max-width="900"
    transition="dialog-bottom-transition"
  >
    <v-card class="p-5" flat>
      <prepared-cards
        v-model="localCardTexts"
        :orders.sync="localOrders"
        :theme.sync="localTheme"
        :type="type"
        @closeModel="isOpen = false"
      />
    </v-card>
  </custom-popup>
</template>

<script>
import PreparedCards from "@/view/pages/qrland/preparedCards";

export default {
  name: "ReadyCardsDialog",
  components: {
    PreparedCards,
  },
  props: {
    value: { type: Boolean, default: false }, // وضعیت باز و بسته بودن پاپ‌آپ
    cardTexts: { type: Object, required: true },
    orders: { type: Array, required: true },
    theme: { type: String, required: true },
    type: { type: String, default: "visitCard" }, // نوع کارت (قابل تغییر در بقیه صفحات)
  },
  computed: {
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    localCardTexts: {
      get() {
        return this.cardTexts;
      },
      set(val) {
        this.$emit("update:cardTexts", val);
      },
    },
    localOrders: {
      get() {
        return this.orders;
      },
      set(val) {
        this.$emit("update:orders", val);
      },
    },
    localTheme: {
      get() {
        return this.theme;
      },
      set(val) {
        this.$emit("update:theme", val);
      },
    },
  },
};
</script>
